module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <button class=\"btn btn-default btn-block\" (click)=\"buyOn('kijiji')\">\n      Buy on kijiji\n    </button>\n  </div>\n  <div class=\"col-xs-12\">\n    <button class=\"btn btn-default btn-block\" (click)=\"buyOn('subito')\">\n      Buy on subito\n    </button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/buy-buttons/buy-buttons.component.html
// module id = 741
// module chunks = 1